import { Component, type ErrorInfo, type ReactNode } from "react";

/**
 * D-044 S5 HOTFIX — root error boundary BELOW ViewAsBanner.
 *
 * Якщо будь-який екран кидає під час рендеру (зокрема у view-as режимі),
 * банер «Вийти» (над цим boundary, на рівні root-layout) ЛИШАЄТЬСЯ видимим —
 * escape-hatch не залежить від цілісності контенту. Boundary показує
 * відновлюваний стан, а не білий екран.
 */
interface State {
  error: Error | null;
}

export class RootErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[KORMAX-ROOT-ERROR]", error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="flex h-full items-center justify-center p-6">
          <div className="w-full max-w-md rounded-lg border bg-card p-6 text-center">
            <p className="text-sm font-medium">Сталася помилка на цій сторінці</p>
            <p className="mt-1 text-xs text-muted-foreground">
              Спробуйте оновити. Якщо ви в режимі перегляду — банер угорі дозволяє вийти.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-4 rounded-md bg-primary px-3.5 py-2 text-sm font-semibold text-primary-foreground"
            >
              Оновити
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
